import styled from 'styled-components'

export const TransactionWrapper = styled.div`
  /* background-color: ${({ theme }) => theme.colors.white}; */
  height: auto;
  width: auto;
  margin-top: 10px;
  /* padding: 0px 10px; */
  border-radius: 10px;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    padding: 0px;
  }
  .transactionHeading {
    display: flex;
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 22px;
    padding: 0px 20px;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme }) => theme.colors.gray};
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      padding: 0px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: ${({ theme }) => theme.colors.CardDark};
    }
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      justify-content: space-between;
    }
  }
  .description {
    width: 17%;
    margin-bottom: 10px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 19%;
    }
  }
  .type {
    width: 35%;
    margin-bottom: 10px;
  }
  .date {
    width: 22%;
    margin-bottom: 10px;
  }
  .amount {
    width: 23%;
    margin-bottom: 10px;
  }

  .title {
    color: ${({ theme }) => theme.colors.transactionHead} !important;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
  }
  .mb {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    .mb {
      display: flex;
    }
    .lg {
      display: none;
    }
  }
`

export const TransactionMoreWrapper = styled.div`
  /* background-color: ${({ theme }) => theme.colors.white}; */
  height: auto;
  width: auto;
  margin-top: 30px;
  /* padding: 0px 10px; */
  border-radius: 10px;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    padding: 0px;
  }
  .transactionHeading {
    display: flex;
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 22px;
    padding: 0px 20px;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme }) => theme.colors.gray};
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      padding: 0px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
    }
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      justify-content: space-between;
    }
  }
  .description {
    flex: 40%;
    margin-bottom: 10px;
  }
  .type {
    flex: 16%;
    margin-bottom: 10px;
  }
  .date {
    flex: 19%;
    margin-bottom: 10px;
  }
  .amount {
    flex: 13%;
    margin-bottom: 10px;
  }
  .status {
    flex: 9%;
    margin-bottom: 10px;
  }
  .title {
    color: ${({ theme }) => theme.colors.transactionHead};
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
  }
  .mb {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    .mb {
      display: flex;
    }
    .lg {
      display: none;
    }
  }
`
